import React, {Fragment} from "react";
import LoadingPlaceholderBlock from "../../../../common/LoadingPlaceholderBlock";

export default function MessageListEmptyState() {
    const EmptyState = () => {
        return(
            <div className="message-list-container">
                <div className="tms-truncate-2-lines message-list-text retain-list-text">
                    <LoadingPlaceholderBlock
                        width={"170px"}
                        height={'19px'}
                        borderRadius={'6px'}
                        backgroundColor={'#EFEAE5'}
                    />
                </div>
                <div>
                    <div className="message-list-date retain-list-date">
                        <LoadingPlaceholderBlock
                            width={"90px"}
                            height={'13px'}
                            borderRadius={'4px'}
                            backgroundColor={'#EFEAE5'}
                        />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Fragment>
            {
                [...new Array(10)].map((item, index) => {
                    return <EmptyState key={index} index={index}/>
                })
            }
        </Fragment>
    )
}